module.exports = __webpack_public_path__ + "static/media/pt.8399d871.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pt.svg
// module id = 229
// module chunks = 0